export default "__VITE_ASSET__DambONB___"